import { useEffect } from 'react'
import { useDispatch} from 'react-redux'
import { resetForm } from './reducer/headerSlice'


const AesEuHeader = ({ shipmentId, renderEuHeader }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        return () => dispatch(resetForm());
    }, [shipmentId])
    return renderEuHeader() 
}

export default AesEuHeader